/**
 * MonthSweep — animation typographique au passage du mois.
 *
 * Quand le tour change, une bande horizontale traverse l'écran avec
 * « AVRIL 2028 » en monumental, puis disparaît. 700ms total. C'est le
 * battement de cœur du jeu — le moment où le joueur sent le temps
 * basculer. Brutalisme cinétique : pas de spring, pas de bounce, juste
 * une page qui se tourne.
 */

import { useEffect, useState } from "react";
import { useGame } from "../store/useGame";

const MONTHS = [
  "JANVIER",
  "FÉVRIER",
  "MARS",
  "AVRIL",
  "MAI",
  "JUIN",
  "JUILLET",
  "AOÛT",
  "SEPTEMBRE",
  "OCTOBRE",
  "NOVEMBRE",
  "DÉCEMBRE",
];

function monthYear(turn: number): { month: string; year: number } {
  const m = turn % 12;
  const y = 2028 + Math.floor(turn / 12);
  return { month: MONTHS[m], year: y };
}

export function MonthSweep() {
  const turn = useGame((s) => s.worldState?.turn ?? 0);
  const [animatingTurn, setAnimatingTurn] = useState<number | null>(null);
  const [previousTurn, setPreviousTurn] = useState<number>(turn);

  useEffect(() => {
    if (turn === previousTurn) return;
    // Pas d'animation au tour 0 (boot initial).
    if (turn === 0) {
      setPreviousTurn(turn);
      return;
    }
    setAnimatingTurn(turn);
    setPreviousTurn(turn);
    const timer = window.setTimeout(() => setAnimatingTurn(null), 720);
    return () => window.clearTimeout(timer);
  }, [turn, previousTurn]);

  if (animatingTurn === null) return null;

  const { month, year } = monthYear(animatingTurn);

  return (
    <div className="month-sweep" aria-hidden="true">
      <div className="month-sweep-band">
        <span className="month-sweep-label">{month}</span>
        <span className="month-sweep-year">{year}</span>
      </div>
    </div>
  );
}
